module.exports = __webpack_public_path__ + "img/traveling.f4dcaf65.svg";